import Marquee from "react-fast-marquee";
import { services } from "@/data/services";

export default function EditorialMarquee() {
  const items = [
    ...services.map((s) => s.name),
    "Halifax",
    "Sydney",
    "Dartmouth",
    "Yarmouth",
    "Truro",
    "Bridgewater",
    "New Glasgow",
    "Cape Breton",
    "Annapolis Valley",
    "South Shore",
    "Since 2007",
  ];
  return (
    <section className="border-y border-[#D9D6D0] bg-[#F5F3EF] py-8 md:py-10 overflow-hidden">
      <Marquee gradient={false} speed={35} pauseOnHover>
        {items.map((item, i) => (
          <span
            key={i}
            className="mx-10 md:mx-14 font-serif italic text-3xl md:text-5xl text-[#111111] flex items-center gap-10 md:gap-14"
          >
            {item}
            <span className="text-[#C17A43] not-italic">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
